const presLensOption = document.querySelector('.pres-lens');
const quote = document.querySelector('.quote');
const uploadCrx = document.querySelector('#custom_photo');
const customRx = document.querySelector('.custom-rx');
const lensOpt = document.querySelector(".lens-options");
const eyeChocice = document.querySelector(".eye");
const use = document.querySelector('.use');
const types = document.querySelector('.l-type');
const tints = document.querySelector('.tints');
const tintCh = document.querySelector("#tintsC");
const coatings = document.querySelector('.coatings');
const coatS = document.querySelector("#coatS");
const sphereR = document.getElementById('sphereR');
const cylinderR = document.getElementById('cylinderR');
const axisR = document.getElementById('axisR');
const inputRx = document.querySelector(".rx-input");
const rxComplete = document.querySelector("#axisL")
const nearAdd = document.querySelector('.near-add');
const addVal = document.querySelector('#add');
const monoCheck = document.querySelector('.checkbox2');
// const prismLoc = document.querySelector('.prism');
// const prismInputR = document.querySelector('.prismR');
// const prismVr = document.querySelector('#prismR')
// const prismDr = document.querySelector("#prismRd")
const prismInputL = document.querySelector('.prismL');
const prismVl = document.querySelector("#prismL");
const prismDl = document.querySelector("#prismLd");
const prismToggle = document.getElementById('prism-select');
const prismRH = document.getElementById('prismR_h');
const prismRbH = document.getElementById('prismRb_h');
const prismRV = document.getElementById('prismR_v');
const prismRbV = document.getElementById('prismRb_v');
const addToCart = document.querySelector('.atc');
const tintReq = document.querySelector("select.tints");
const reqs = document.querySelectorAll('.req');
const custDetail = document.querySelector(".form-group");
const quoteUpload = document.querySelector("#custom_photo-1");
const pxlensInfoP = document.querySelector("#custom_photo");
const upLoadRx = document.querySelector(".upload-rx");
const pxLensInfoQ = document.querySelector("#upload");
const pxAddition = document.querySelector("#exampleFormControlTextarea1");
const RinputRx = document.querySelector('.rx-input-r');
const segShape = document.querySelector('.seg-shape');
const clearOpt = document.querySelector('.reset');
const polarOpt = document.querySelector("select.l-type.req > option:nth-child(4)")
const textArea = document.querySelector(".text-area");
const ageCheck = document.querySelector(".checkbox");
const inputsAdv = document.querySelectorAll('.rx-L');
const rxFinal = document.querySelector("#axisL");
const trans = document.querySelector('.tran');
const tranLabel = document.querySelectorAll('.tran label');
const blueBlock = document.querySelector('.blueblock');
const blueBlockRadios = blueBlock.querySelectorAll('input[type="radio"]');
const tintRadios = tints.querySelectorAll('input[type="radio"]');
const transRadios = trans.querySelectorAll('input[type="radio"]');
const bquest = document.querySelector('.bquest');
const bGuide = document.querySelector('.bguide');
const popupClose = document.querySelector('.popup-close');
const scriptType = document.querySelector(".rx-clarif");
const scriptOptions = document.querySelector("#rxClarif");
const addInput = document.querySelector('#add');
const allInputs = document.querySelectorAll('.rx-input');
const productTitle = document.querySelector('.product-single__title');

// Load in customer Rx details to speed up UX
sphereR.value = localStorage.getItem('sphereR');
cylinderR.value = localStorage.getItem('cylinderR');
axisR.value = localStorage.getItem('axisR');
// prismR.value = localStorage.getItem('prismR');
// prismRd.value = localStorage.getItem('prismRd');

// ------------------------
// Prism (split H + V) - required logic
// ------------------------
const prismLoc = document.querySelector('.prism'); // you currently commented this out - you NEED it

function prismAnyValueSelected() {
  const hHas = prismRH && prismRH.value && prismRH.value !== '0.00';
  const vHas = prismRV && prismRV.value && prismRV.value !== '0.00';
  return !!(hHas || vHas);
}

function storePrism() {
  try {
    localStorage.setItem('prismR_h', prismRH?.value || '0.00');
    localStorage.setItem('prismRb_h', prismRbH?.value || '');
    localStorage.setItem('prismR_v', prismRV?.value || '0.00');
    localStorage.setItem('prismRb_v', prismRbV?.value || '');
  } catch (e) {}
}

function loadPrism() {
  try {
    const h = localStorage.getItem('prismR_h');
    const hb = localStorage.getItem('prismRb_h');
    const v = localStorage.getItem('prismR_v');
    const vb = localStorage.getItem('prismRb_v');

    if (h !== null && prismRH) prismRH.value = h;
    if (hb !== null && prismRbH) prismRbH.value = hb;
    if (v !== null && prismRV) prismRV.value = v;
    if (vb !== null && prismRbV) prismRbV.value = vb;
  } catch (e) {}
}

function showHidePrism() {
  if (!prismToggle || !prismLoc) return;

  if (prismToggle.checked) {
    prismLoc.classList.remove('d-none');
  } else {
    prismLoc.classList.add('d-none');

    // Clear values when off (clean UX)
    if (prismRH) prismRH.value = '0.00';
    if (prismRbH) prismRbH.value = '';
    if (prismRV) prismRV.value = '0.00';
    if (prismRbV) prismRbV.value = '';

    storePrism();
  }
}

// Init
loadPrism();

// If stored values exist, auto-enable Prism
if (prismToggle && prismAnyValueSelected()) {
  prismToggle.checked = true;
}
showHidePrism();

// Toggle handler
if (prismToggle) {
  prismToggle.addEventListener('change', showHidePrism);
}

// Save on any prism dropdown change
[prismRH, prismRbH, prismRV, prismRbV].forEach((el) => {
  if (!el) return;
  el.addEventListener('change', storePrism);
});


eyeChocice.addEventListener('change', (e) => {
        use.classList.remove('d-none');
        eyeChocice.classList.add('picked');
    })

const clearTypesForm = function () {
    inputRx.classList.add('d-none');
    coatings.classList.add('d-none');
    tints.classList.add('d-none');
    types.classList.remove('d-none');
    types.value = "";
    add.value = "";
    coatS.value = "";
    tints.value - "";
    add.value = "";
    trans.value = "";
    blueBlock.value = "";
    blueBlock.classList.remove('picked');
    blueBlock.classList.add('d-none');
    trans.classList.add('d-none');
    types.classList.remove('picked');
    types.classList.remove('d-none');
    use.classList.add('picked');
    upLoadRx.classList.add('d-none');  
    use.classList.add('picked');
    trans.classList.add('d-none');
    upLoadRx.classList.add('d-none');
    segShape.classList.add('d-none');
    segShape.value = "";
    segShape.classList.remove('picked');
    nearAdd.classList.add('d-none');
    addVal.removeAttribute('required');
    scriptType.classList.add('d-none');
    scriptType.value = "";
    scriptType.classList.remove('picked');
    tranLabel.forEach(label => {
        const radio = label.querySelector('input[type="radio"]');
        if (radio && radio.value !== 'greyt' && radio.value !== 'brownt') {
            label.classList.remove('d-none');
        }

        Array.from(types.children).forEach(child => {
            if (child.value == 'polarised' || child.value == 'transitions') {
                child.classList.remove('d-none');
            }
        })
    });

    clearAllInputs();
}

const showAdd = function () {
    nearAdd.classList.remove('d-none');
    add.classList.add('adv', 'req');
    add.setAttribute('required', add);
}

use.addEventListener('change', (e) => {
    clearTypesForm();
    if (use.value == 'distance') {
        nearAdd.classList.add('d-none');      // Needed to override nearAdd’s removal of 'd-none'
        // types.classList.remove('d-none');
        use.classList.add('picked');
        add.classList.remove('adv', 'req');
        addVal.removeAttribute('required');
    } else if (use.value == 'reading') {             
        
    } else if (use.value == 'bifocal') {
        segShape.classList.remove('d-none');
        types.classList.add('d-none');
        
    } else if (use.value == 'varifocal') {         
    } else;
});

const clearTintsInput = function () {
        tintRadios.forEach(radio => {
          radio.checked = false;
        });
      }

const clearTranInput = function () {
        transRadios.forEach(radio => {
          radio.checked = false;
        });
      }

const clearBlueblockInput = function () {
        blueBlockRadios.forEach(radio => {
          radio.checked = false;
        });
    }

const clearAllInputs = function () {
    clearBlueblockInput();
    clearTranInput();
    clearTintsInput();
}

function resetCommon() {
    clearAllInputs();
    coatS.value = "";
    blueBlock.value = "";
    tints.value = "";
    trans.value = "";
    scriptType.value = "";
  }

  const clearTypesSun = function () {
    tints.classList.remove('d-none');    
    coatings.classList.add('d-none');
    tints.setAttribute('required', true);    
    blueBlock.classList.add('d-none');
    tints.classList.remove('picked');
    inputRx.classList.add('d-none');
    resetCommon();
  };
  
  const clearTypesClear = () => {
    tints.classList.add('d-none');
    coatings.classList.remove('d-none');
    coatings.classList.add('picked');
    blueBlock.classList.add('d-none');
    trans.classList.add('d-none');
    types.classList.add('picked');
    resetCommon();
    coatS.value = "hard coat";
  };
  
  const clearTypesBlue = function () {
    blueBlock.classList.remove('d-none');
    blueBlock.classList.remove('picked');
    tints.classList.add('d-none');
    tints.classList.remove('picked');
    coatings.classList.add('d-none');
    coatings.classList.remove('picked');
    inputRx.classList.add('d-none');
    trans.classList.add('d-none');
    trans.selectedIndex = 0;
    trans.classList.remove('picked');
    scriptType.classList.add('d-none');
    scriptType.classList.remove('picked');
    resetCommon();
  };

types.addEventListener('change', e => {
    types.classList.add('picked');
    upLoadRx.classList.add('done');
    inputRx.classList.add('d-none');
    resetCommon();
    if (types.value == 'clear') {
        inputRx.classList.remove('d-none');
        trans.classList.add('d-none');
        coatings.classList.remove('d-none');
        coatings.classList.add('picked');
        coatS.value = "hard coat";
        tints.classList.add('d-none');
        blueBlock.classList.add('d-none');    
    if(use.value == 'distance') {        
        
    }else if(use.value == 'reading' || use.value == 'varifocal' || use.value == "bifocal") {
        scriptType.classList.remove('d-none');
        inputRx.classList.add('d-none');
        
    }else;

    }if(types.value == 'bluelight') {
       
        clearBlueblockInput();
        clearTypesBlue();

    if(use.value == 'distance') {
            blueBlock.classList.remove('d-none');  

    }else if(use.value == 'reading' || use.value == 'varifocal' || use.value == "bifocal") {
        blueBlock.classList.remove('d-none');
        clearTypesBlue();
        scriptType.classList.add('d-none');
        scriptType.classList.remove('picked');
        scriptType.value = "";
        scriptType.setAttribute('required', true);
        }else;

    }if(types.value == 'sunglasses' || types.value == 'polarised' ) {
        blueBlock.classList.add('d-none');
        trans.classList.add('d-none');
        tints.classList.remove('d-none');
        tints.classList.remove('picked');
        inputRx.classList.add('d-none');
        clearTintsInput();
        scriptType.classList.add('d-none');
        scriptType.classList.remove('picked');
        scriptType.value = "";
        if(use.value == 'distance' || use.value == 'reading' ) {

        trans.classList.add('d-none');
    }else if(use.value == 'varifocal' || use.value == "bifocal") {
        tints.classList.remove('d-none');
        tints.classList.remove('picked');
        trans.classList.add('d-none');
        clearTypesSun();
        clearTintsInput();
        // scriptType.classList.remove('d-none');
        scriptType.setAttribute('required', true);

        tintRadios.forEach(radio => {
            if(radio.value === 'green') {
                radio.closest('label').classList.remove('d-none');
            }
        })
        }else;
    }

    if(types.value == 'transitions') {
        clearTranInput();
        blueBlock.classList.add('d-none');
        trans.classList.remove('d-none');
        trans.classList.remove('picked');
        coatings.classList.add('d-none');
        inputRx.classList.add('d-none');
        scriptType.classList.add('d-none');
        scriptType.classList.remove('picked');
        scriptType.value = "";

        if(use.value == 'distance' || use.value == 'reading' || use.value == 'varifocal') {
        tints.classList.add('d-none');
        tints.classList.remove('picked');

    }else if(use.value == 'bifocal' && segShape.value === "d28") {
            tints.classList.add('d-none');
            trans.classList.remove('d-none');
            // scriptType.classList.remove('d-none');
            scriptType.setAttribute('required', true);
    }else;
    }

    if(use.value == 'reading') {
        const soArray = Array.from(scriptOptions);
        soArray[1].classList.add('d-none');
        soArray[2].classList.remove('d-none');
        soArray[3].classList.remove('d-none');
        soArray[4].classList.remove('d-none');

    }else if(use.value == 'varifocal' || use.value == 'bifocal') {
        const soArray = Array.from(scriptOptions);
        soArray[1].classList.remove('d-none');
        soArray[2].classList.remove('d-none');
        soArray[3].classList.add('d-none');
        soArray[4].classList.add('d-none');

    }else;
        
})

bquest.addEventListener('click', e => {
    bGuide.classList.remove('d-none');
})

popupClose.addEventListener('click', e => {
    bGuide.classList.add('d-none');
})

tints.addEventListener('change', e => {
    tints.classList.add('picked');
    inputRx.classList.remove('d-none');

    if(use.value == 'reading'  || use.value == 'bifocal'  || use.value == 'varifocal') {
        inputRx.classList.add('d-none');
        scriptType.classList.remove('d-none');
    }
})

trans.addEventListener('change', e => {
    trans.classList.add('picked');
    inputRx.classList.remove('d-none');
    if(use.value == 'reading'  || use.value == 'bifocal'  || use.value == 'varifocal') {
        inputRx.classList.add('d-none');
        scriptType.classList.remove('d-none');
    }
})

blueBlock.addEventListener('change', e => {
    if(use.value == 'reading' || use.value == 'varifocal' || use.value == "bifocal"){
        scriptType.classList.remove('d-none');
        blueBlock.classList.add('picked');
        return;
    }
    blueBlock.classList.add('picked');
    inputRx.classList.remove('d-none');
    trans.classList.add('d-none');
})

segShape.addEventListener('change', e => {
    types.classList.remove('d-none');
    segShape.classList.add('picked');
    coatings.classList.add('d-none');
    trans.classList.add('d-none');
    types.value = '';
    types.classList.remove('picked');
    blueBlock.classList.remove('picked');
    blueBlock.classList.add('d-none');
    inputRx.classList.add('d-none');
    scriptType.classList.add('d-none');

    if (segShape.value == 'd28') {
        coatS.style.diplay = "none";
        Array.from(types.children).forEach(child => {
            if (child.value == 'polarised' || child.value == 'transitions') {
                child.classList.remove('d-none');
            }
        })
    }
   
    if (segShape.value == 'r24') {
        coatS.style.diplay = "none";
        Array.from(types.children).forEach(child => {
            if (child.value == 'polarised' || child.value == 'transitions') {
                child.classList.add('d-none');
            }
        })
    }

    tranLabel.forEach(label => {
        const radio = label.querySelector('input[type="radio"]');
        if (radio && radio.value !== 'greyt' && radio.value !== 'brownt') {
            label.classList.add('d-none');
        }
    });
})

const stAddRem = function () {
    nearAdd.classList.add('d-none');
    add.classList.remove('adv', 'req');
    add.removeAttribute('required');      
    scriptType.classList.add('picked');
    inputRx.classList.remove('d-none');
}

const nearRx = document.createElement('div');
nearRx.innerHTML = `<div class="class twoRxs">
<div class="rx-input-r">
<p class="clear"><strong>Near</strong></p>
<div class="pformat">
<div class="rx-l col-xs-2">
<label>Sphere</label></br>
<select id="sphereRnear" class="req adv" name="properties[_RsphereNear]">
  <option value=""></option>
  <option value="0.00"> 0.00</option>
  <option value="-0.25">-0.25</option>
  <option value="-0.50">-0.50</option>
  <option value="-0.75">-0.75</option>
  <option value="-1.00">-1.00</option>
  <option value="-1.25">-1.25</option>
  <option value="-1.50">-1.50</option>
  <option value="-1.75">-1.75</option>
  <option value="-2.00">-2.00</option>
  <option value="-2.25">-2.25</option>
  <option value="-2.50">-2.50</option>
  <option value="-2.75">-2.75</option>
  <option value="-3.00">-3.00</option>
  <option value="-3.25">-3.25</option>
  <option value="-3.50">-3.50</option>
  <option value="-3.75">-3.75</option>
  <option value="-4.00">-4.00</option>
  <option value="-4.25">-4.25</option>
  <option value="-4.50">-4.50</option>
  <option value="-4.75">-4.75</option>
  <option value="-5.00">-5.00</option>
  <option value="-5.25">-5.25</option>
  <option value="-5.50">-5.50</option>
  <option value="-5.75">-5.75</option>
  <option value="-6.00">-6.00</option>
  <option value="-6.25">-6.25</option>
  <option value="-6.50">-6.50</option>
  <option value="-6.75">-6.75</option>
  <option value="-7.00">-7.00</option>
  <option value="-7.25">-7.25</option>
  <option value="-7.50">-7.50</option>
  <option value="-7.75">-7.75</option>
  <option value="-8.00">-8.00</option>
  <option value="-8.25">-8.25</option>
  <option value="-8.50">-8.50</option>
  <option value="-8.75">-8.75</option>
  <option value="-9.00">-9.00</option>
  <option value="-9.25">-9.25</option>
  <option value="-9.50">-9.50</option>
  <option value="-9.75">-9.75</option>
  <option value="-10">-10.00</option>
  <option value="0.25">+0.25</option>
  <option value="0.5">+0.50</option>
  <option value="0.75">+0.75</option>
  <option value="1">+1.00</option>
  <option value="1.25">+1.25</option>
  <option value="1.5">+1.50</option>
  <option value="1.75">+1.75</option>
  <option value="2">+2.00</option>
  <option value="2.25">+2.25</option>
  <option value="2.5">+2.50</option>
  <option value="2.75">+2.75</option>
  <option value="3">+3.00</option>
  <option value="3.25">+3.25</option>
  <option value="3.5">+3.50</option>
  <option value="3.75">+3.75</option>
  <option value="4">+4.00</option>
  <option value="4.25">+4.25</option>
  <option value="4.5">+4.50</option>
  <option value="4.75">+4.75</option>
  <option value="5">+5.00</option>
  <option value="5.25">+5.25</option>
  <option value="5.5">+5.50</option>
  <option value="5.75">+5.75</option>
  <option value="6">+6.00</option>
  <option value="6.25">+6.25</option>
  <option value="6.5">+6.50</option>
  <option value="6.75">+6.75</option>
  <option value="7">+7.00</option>
  <option value="7.25">+7.25</option>
  <option value="7.5">+7.50</option>
  <option value="7.75">+7.75</option>
  <option value="8">+8.00</option>
  <option value="0.00">&#8734</option>
  <option value="Balance">Bal</option>
</select>
</div>

<div class="rx-l col-xs-2">
<label>Cyl</label><br>
<select class="req adv" id="cylinderRNear" class="req adv" name="properties[_RcylinderNear]">
  <option value=""></option>
  <option value="0.00">None</option>
  <option value="-0.25">-0.25</option>
        <option value="-0.50">-0.50</option>
        <option value="-0.75">-0.75</option>
        <option value="-1.00">-1.00</option>
        <option value="-1.25">-1.25</option>
        <option value="-1.50">-1.50</option>
        <option value="-1.75">-1.75</option>
        <option value="-2.00">-2.00</option>
        <option value="-2.25">-2.25</option>
        <option value="-2.50">-2.50</option>
        <option value="-2.75">-2.75</option>
        <option value="-3.00">-3.00</option>
        <option value="-3.25">-3.25</option>
        <option value="-3.50">-3.50</option>
        <option value="-3.75">-3.75</option>
        <option value="-4.00">-4.00</option>
        <option value="-4.25">-4.25</option>
        <option value="-4.50">-4.50</option>
        <option value="-4.75">-4.75</option>
        <option value="-5.00">-5.00</option>
        <option value="-5.25">-5.25</option>
        <option value="-5.50">-5.50</option>
        <option value="-5.75">-5.75</option>
        <option value="-6.00">-6.00</option>
        <option value="0.25">+0.25</option>
        <option value="0.50">+0.50</option>
        <option value="0.75">+0.75</option>
        <option value="1.00">+1.00</option>
        <option value="1.25">+1.25</option>
        <option value="1.50">+1.50</option>
        <option value="1.75">+1.75</option>
        <option value="2.00">+2.00</option>
        <option value="2.25">+2.25</option>
        <option value="2.50">+2.50</option>
        <option value="2.75">+2.75</option>
        <option value="3.00">+3.00</option>
        <option value="3.25">+3.25</option>
        <option value="3.50">+3.50</option>
        <option value="3.75">+3.75</option>
        <option value="4.00">+4.00</option>
        <option value="4.25">+4.25</option>
        <option value="4.50">+4.50</option>
        <option value="4.75">+4.75</option>
        <option value="5.00">+5.00</option>
        <option value="5.25">+5.25</option>
        <option value="5.50">+5.50</option>
        <option value="5.75">+5.75</option>
        <option value="6.00">+6.00</option>
</select>
</div>

<div class="rx-l col-xs-2">
<label>Axis</label><br>
<select id="axisRNear" class="req adv" name="properties[_axisRNear]">
  <option value=""></option>
  <option value="0.00">None</option>
  <option value="1">1</option>
  <option value="2">2</option>
  <option value="3">3</option>
  <option value="4">4</option>
  <option value="5">5</option>
  <option value="6">6</option>
  <option value="7">7</option>
  <option value="8">8</option>
  <option value="9">9</option>
  <option value="10">10</option>
  <option value="11">11</option>
  <option value="12">12</option>
  <option value="13">13</option>
  <option value="14">14</option>
  <option value="15">15</option>
  <option value="16">16</option>
  <option value="17">17</option>
  <option value="18">18</option>
  <option value="19">19</option>
  <option value="20">20</option>
  <option value="21">21</option>
  <option value="22">22</option>
  <option value="23">23</option>
  <option value="24">24</option>
  <option value="25">25</option>
  <option value="26">26</option>
  <option value="27">27</option>
  <option value="28">28</option>
  <option value="29">29</option>
  <option value="30">30</option>
  <option value="31">31</option>
  <option value="32">32</option>
  <option value="33">33</option>
  <option value="34">34</option>
  <option value="35">35</option>
  <option value="36">36</option>
  <option value="37">37</option>
  <option value="38">38</option>
  <option value="39">39</option>
  <option value="40">40</option>
  <option value="41">41</option>
  <option value="42">42</option>
  <option value="43">43</option>
  <option value="44">44</option>
  <option value="45">45</option>
  <option value="46">46</option>
  <option value="47">47</option>
  <option value="48">48</option>
  <option value="49">49</option>
  <option value="50">50</option>
  <option value="51">51</option>
  <option value="52">52</option>
  <option value="53">53</option>
  <option value="54">54</option>
  <option value="55">55</option>
  <option value="56">56</option>
  <option value="57">57</option>
  <option value="58">58</option>
  <option value="59">59</option>
  <option value="60">60</option>
  <option value="61">61</option>
  <option value="62">62</option>
  <option value="63">63</option>
  <option value="64">64</option>
  <option value="65">65</option>
  <option value="66">66</option>
  <option value="67">67</option>
  <option value="68">68</option>
  <option value="69">69</option>
  <option value="70">70</option>
  <option value="71">71</option>
  <option value="72">72</option>
  <option value="73">73</option>
  <option value="74">74</option>
  <option value="75">75</option>
  <option value="76">76</option>
  <option value="77">77</option>
  <option value="78">78</option>
  <option value="79">79</option>
  <option value="80">80</option>
  <option value="81">81</option>
  <option value="82">82</option>
  <option value="83">83</option>
  <option value="84">84</option>
  <option value="85">85</option>
  <option value="86">86</option>
  <option value="87">87</option>
  <option value="88">88</option>
  <option value="89">89</option>
  <option value="90">90</option>
  <option value="91">91</option>
  <option value="92">92</option>
  <option value="93">93</option>
  <option value="94">94</option>
  <option value="95">95</option>
  <option value="96">96</option>
  <option value="97">97</option>
  <option value="98">98</option>
  <option value="99">99</option>
  <option value="100">100</option>
  <option value="101">101</option>
  <option value="102">102</option>
  <option value="103">103</option>
  <option value="104">104</option>
  <option value="105">105</option>
  <option value="106">106</option>
  <option value="107">107</option>
  <option value="108">108</option>
  <option value="109">109</option>
  <option value="110">110</option>
  <option value="111">111</option>
  <option value="112">112</option>
  <option value="113">113</option>
  <option value="114">114</option>
  <option value="115">115</option>
  <option value="116">116</option>
  <option value="117">117</option>
  <option value="118">118</option>
  <option value="119">119</option>
  <option value="120">120</option>
  <option value="121">121</option>
  <option value="122">122</option>
  <option value="123">123</option>
  <option value="124">124</option>
  <option value="125">125</option>
  <option value="126">126</option>
  <option value="127">127</option>
  <option value="128">128</option>
  <option value="129">129</option>
  <option value="130">130</option>
  <option value="131">131</option>
  <option value="132">132</option>
  <option value="133">133</option>
  <option value="134">134</option>
  <option value="135">135</option>
  <option value="136">136</option>
  <option value="137">137</option>
  <option value="138">138</option>
  <option value="139">139</option>
  <option value="140">140</option>
  <option value="141">141</option>
  <option value="142">142</option>
  <option value="143">143</option>
  <option value="144">144</option>
  <option value="145">145</option>
  <option value="146">146</option>
  <option value="147">147</option>
  <option value="148">148</option>
  <option value="149">149</option>
  <option value="150">150</option>
  <option value="151">151</option>
  <option value="152">152</option>
  <option value="153">153</option>
  <option value="154">154</option>
  <option value="155">155</option>
  <option value="156">156</option>
  <option value="157">157</option>
  <option value="158">158</option>
  <option value="159">159</option>
  <option value="160">160</option>
  <option value="161">161</option>
  <option value="162">162</option>
  <option value="163">163</option>
  <option value="164">164</option>
  <option value="165">165</option>
  <option value="166">166</option>
  <option value="167">167</option>
  <option value="168">168</option>
  <option value="169">169</option>
  <option value="170">170</option>
  <option value="171">171</option>
  <option value="172">172</option>
  <option value="173">173</option>
  <option value="174">174</option>
  <option value="175">175</option>
  <option value="176">176</option>
  <option value="177">177</option>
  <option value="178">178</option>
  <option value="179">179</option>
  <option value="180">180</option>
</select>
</div>
</div>
</div>
</div>`;

scriptType.addEventListener('change', e => {
if(scriptOptions.value == 'twodistnear') {
    inputRx.append(nearRx);
    nearRx.style = "margin-bottom: 10px;";
    stAddRem();
}else if(scriptOptions.value == 'distadd' && use.value == 'bifocal') {
    inputRx.classList.remove('d-none');
    scriptType.classList.add('picked');
    inputRx.classList.remove('picked');

}else if(scriptOptions.value == 'distadd' && use.value == 'varifocal'){
    scriptType.classList.add('picked');
    inputRx.classList.remove('d-none');
    inputRx.classList.remove('picked');
}else if(use.value == 'reading' && scriptOptions.value == 'twodistnear' || scriptOptions.value == 'onlyread') {
    stAddRem();
    scriptType.classList.remove('d-none');
    inputTitle.innerHTML = `Enter Near Prescription`;
    nearRx.remove();
}

if(scriptOptions.value == 'distadd') {
    inputRx.classList.remove('d-none');
    scriptType.classList.add('picked');
    nearAdd.classList.remove('d-none');
    nearRx.remove();
}
    
if (scriptOptions.value == 'onlycomp') {
    stAddRem();
    inputTitle.innerHTML = `Enter Computer / Inter Prescription`;
}else;
})

// open pd box when distance selected
inputRx.addEventListener('change', (e) => {
    localStorage.setItem('sphereR', sphereR.value);
    localStorage.setItem('cylinderR', cylinderR.value);
    localStorage.setItem('axisR', axisR.value);
    localStorage.setItem('add', add.value);
  
    
    if(cylinderR.value === '0.00') {
            axisR.value = cylinderR.value;
        }
  
    // If user’s lens selection is bifocal or varifocal...
    if (use.value === 'bifocal' || use.value === 'varifocal') {
      // ...and if scriptType is "twodistnear"
      if (scriptType.value === 'twodistnear') {
        // Right eye logic
        if (cylinderR.value !== '0.00') {
          cylinderRNear.value = cylinderR.value;
          axisRNear.value = axisR.value;
        } else {
          cylinderRNear.value = '0.00';
          axisRNear.value = '0.00';
        }
      }
    }
  });
  

pxlensInfoP.addEventListener('change', e => {
    upLoadRx.classList.add('picked');
})

// prismCheck.addEventListener('click', e => {
//     if (e.target.checked == true) {
//         prismLoc.classList.remove('d-none');
//     } else if (e.target.checked == false) {
//         prismLoc.classList.add('d-none');
//     };
// })

// prismLoc.addEventListener('change', e => {
//     localStorage.setItem('prismR', prismR.value);
//     localStorage.setItem('prismRd', prismRd.value);
// })

function getDawnLensPills() {
  // Find the Lens fieldset inside variant-selects
  const fieldsets = Array.from(document.querySelectorAll('variant-selects fieldset'));
  const lensFs = fieldsets.find(fs =>
    (fs.querySelector('legend')?.textContent || '').trim().toLowerCase() === 'lens'
  ) || fieldsets[0];

  if (!lensFs) return [];

  // Only the variant option pills (NOT your own tints/blueblock radios)
  const pills = Array.from(lensFs.querySelectorAll('input[type="radio"]'));

  // Extra safety: Dawn pills often have a "form" attribute pointing at the product form id
  const productForm = document.querySelector('form[action*="/cart/add"]');
  const productFormId = productForm?.id;
  const filtered = productFormId
    ? pills.filter(r => (r.getAttribute('form') || '') === productFormId)
    : pills;

  return filtered.length ? filtered : pills;
}

function setDawnLensPillByIndex(index) {
  const pills = getDawnLensPills();
  if (!pills.length) return false;

  const safeIndex = Math.max(0, Math.min(index, pills.length - 1));
  const target = pills[safeIndex];

  // Force selection + trigger Dawn listeners
  target.checked = true;
  target.dispatchEvent(new Event('input', { bubbles: true }));
  target.dispatchEvent(new Event('change', { bubbles: true }));
  target.click(); // some themes rely on click handlers too

  return true;
}


// clear lens option choices to let Px reselect options easily and remove previuous choices set price to lowest.
clearOpt && clearOpt.addEventListener('click', (e) => {
  e.preventDefault();

  // Remove any out-of-range lock UI
  document.documentElement.classList.remove('mm-lens-oorr');

  // 1) Set Dawn variant back to base pill (index 0)
  const ok = setDawnLensPillByIndex(0);

  // 2) Clear storage so your script doesn't re-apply anything
  try { localStorage.clear(); } catch (err) {}
  try { sessionStorage.clear(); } catch (err) {}

  // 3) After Dawn updates the hidden variant id, rewrite the URL so reload stays on base
  setTimeout(() => {
    const form = document.querySelector('form[action*="/cart/add"]');
    const baseId = form?.querySelector('input[name="id"]')?.value;

    const url = new URL(window.location.href);

    if (baseId) {
      // Force URL to base variant
      url.searchParams.set('variant', baseId);
    } else {
      // Fallback: remove variant param entirely
      url.searchParams.delete('variant');
    }

    history.replaceState({}, '', url.toString());

    // 4) Reload
    window.location.reload();
  }, ok ? 250 : 0);
});



// ------------------------
// Dawn-friendly selectors
// ------------------------
const updatePrice = document.querySelector(".total-cost > span") || null;

// Dawn product form (the real cart/add form)
const form = document.querySelector('form[action*="/cart/add"]') || null;
const submitOrder = form;

// Optional: if you use a custom "total-cost" element keep it,
// otherwise Dawn handles price updates natively.
const price = document.querySelector('.total-cost') || null;
const inputChange = document.querySelector(".rx-input") || null;

// --- Dawn: find the specific option group that represents your "lens package" option ---
// Works whether Dawn renders radios (variant-radios) OR a select (variant-selects)
function getLensOptionInputs() {
  // A) Dawn variant-radios (some product templates use this)
  const radiosFieldsets = Array.from(document.querySelectorAll('variant-radios fieldset'));
  const bestRadiosFieldset =
    radiosFieldsets.find(fs => (fs.querySelector('legend')?.textContent || '').toLowerCase().includes('lens')) ||
    radiosFieldsets.find(fs => (fs.querySelector('legend')?.textContent || '').toLowerCase().includes('package')) ||
    radiosFieldsets.find(fs => (fs.querySelector('legend')?.textContent || '').toLowerCase().includes('type')) ||
    radiosFieldsets[0];

  if (bestRadiosFieldset) {
    const radios = bestRadiosFieldset.querySelectorAll('input[type="radio"]');
    if (radios && radios.length) return { mode: 'radios', nodes: radios };
  }

  // B) Dawn variant-selects, but rendered as pill radios (YOUR CURRENT SETUP)
  const vsFieldsets = Array.from(document.querySelectorAll('variant-selects fieldset'));
  const bestVsFieldset =
    vsFieldsets.find(fs => (fs.querySelector('legend')?.textContent || '').toLowerCase().includes('lens')) ||
    vsFieldsets.find(fs => (fs.querySelector('legend')?.textContent || '').toLowerCase().includes('package')) ||
    vsFieldsets.find(fs => (fs.querySelector('legend')?.textContent || '').toLowerCase().includes('type')) ||
    vsFieldsets[0];

  if (bestVsFieldset) {
    const vsRadios = bestVsFieldset.querySelectorAll('input[type="radio"]');
    if (vsRadios && vsRadios.length) return { mode: 'radios', nodes: vsRadios };

    const vsSelect = bestVsFieldset.querySelector('select');
    if (vsSelect) return { mode: 'select', nodes: vsSelect };
  }

  // C) Fallback: any select inside variant-selects
  const anySelect = document.querySelector('variant-selects select');
  if (anySelect) return { mode: 'select', nodes: anySelect };

  return { mode: 'none', nodes: null };
}

function clickLensOptionByIndex(index) {
  const found = getLensOptionInputs();

  if (found.mode === 'radios') {
    const radios = Array.from(found.nodes);
    if (!radios[index]) return false;

    radios[index].checked = true;
    radios[index].click();
    radios[index].dispatchEvent(new Event('change', { bubbles: true }));
    return true;
  }

  if (found.mode === 'select') {
    const sel = found.nodes;
    if (!sel.options || !sel.options[index]) return false;

    sel.selectedIndex = index;
    sel.dispatchEvent(new Event('change', { bubbles: true }));
    return true;
  }

  return false;
}

//remove price and add to cart function > for when Rx is out of range
const remPriceCart = function () {
  // 1) Ensure contact link + error message appear (no duplicates)
  const quoteElement = document.querySelector('.quote');
  if (quoteElement) quoteElement.classList.remove('d-none');

  const msg = "Sorry your powers are out of range. Please click Contact Us above and we’ll help find suitable lenses for you.";
  let errorEl = document.querySelector('.mm-lens-oorr-message');

  if (!errorEl) {
    errorEl = document.createElement('p');
    errorEl.className = 'mm-lens-oorr-message';
    errorEl.textContent = msg;

    // Place it near the quote/contact link if possible, otherwise near top of lens selector
    if (quoteElement && quoteElement.parentNode) {
      quoteElement.parentNode.insertBefore(errorEl, quoteElement.nextSibling);
    } else {
      const container = document.querySelector('[data-mm-lens-selector]') || document.querySelector('.pres-lens') || document.body;
      container.prepend(errorEl);
    }
  }

  // 2) Hard-block add-to-cart at the FORM level (works even if buttons change)
  const form = document.querySelector('form[action*="/cart/add"]');
  if (form && !form.dataset.mmBlocked) {
    form.dataset.mmBlocked = 'true';

    form.addEventListener('submit', function (e) {
      // if still blocked, stop the add
      if (document.documentElement.classList.contains('mm-lens-oorr')) {
        e.preventDefault();
        e.stopPropagation();
      }
    }, true);
  }

  // 3) Visually disable/hide buy UI in Dawn (CSS class based, robust)
  document.documentElement.classList.add('mm-lens-oorr');

  // 4) Optional: disable all submit/add buttons explicitly (extra safety)
  const disable = (el) => {
    if (!el) return;
    el.setAttribute('disabled', 'disabled');
    el.classList.add('disabled');
    el.style.pointerEvents = 'none';
    el.style.opacity = '0.5';
  };

  disable(document.querySelector('button[name="add"]'));
  disable(document.querySelector('.product-form__submit'));

  // 5) Scroll to top / title so user sees the message
  const productTitle =
    document.querySelector('.product__title') ||
    document.querySelector('h1');

  if (productTitle && productTitle.scrollIntoView) {
    productTitle.scrollIntoView({ behavior: 'smooth', block: 'start' });
  } else {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
};
  

// compare the absolute values to determine lens index
customRx.addEventListener('change', e => {
    const totSphR = Math.abs((Number(sphereR.value)) + (Number(cylinderR.value)));
    const totReadR = (Number(sphereR.value)) + (Number(add.value));
    const powerS = [totSphR, Math.abs(Number(sphereR.value)), Math.abs(Number(cylinderR.value)), totReadR];
    const powerM = [totSphR, Math.abs(Number(sphereR.value)), Math.abs(Number(cylinderR.value))];

    //check for all distance RX fields to be completed
   pxInputRx = inputRx.querySelectorAll('.adv')
    const inPuts = [];

    pxInputRx.forEach(input => {
        // If the input value is empty, remove the "picked" class and skip further processing.
        if (input.value === "") {
          inputRx.classList.remove('picked');
          return; // Continue to the next iteration
        }
      
        // Check if the three arrays have elements
        if (sphereR.length > 0 && cylinderR.length > 0 && axisR.length > 0) {
          inPuts.push(input);
      
          // For 'distance' or 'reading' use, expect 3 inputs.
          if((use.value === 'distance' || use.value === 'reading' && scriptType.value != 'distadd') && inPuts.length === 3) {
            inputRx.classList.add('picked');
            upLoadRx.classList.remove('d-none');
          }

          if(scriptOptions.value == 'twodistnear' && inPuts.length === 6) {
            inputRx.classList.add('picked');
            upLoadRx.classList.remove('d-none');
          }
        } else;
      });

allInputs.forEach(input => {
    if(scriptOptions.value == 'distadd') {
        if(sphereR.value != "" && cylinderR.value != "" && axisR.value != "" && add.value != ""){
            upLoadRx.classList.remove('d-none');
            inputRx.classList.add('picked');  
        }
     
        if(scriptOptions.value == 'twodistnear') {
            if(sphereR.value != "" && cylinderR.value != "" && axisR.value != "" && sphereRnear.value != "" && cylinderRNear.value != "" && axisRNear.value != "") {
                upLoadRx.classList.remove('d-none');
                inputRx.classList.add('picked'); 
            }
        }
        }
    });

    // Sorts the highest absolute value
    const powerLensSv = powerS.sort((a, b) => {
        return b - a
    });

    if (use.value == 'distance' || use.value == 'reading' || use.value == 'nearadd') {
        if (types.value == 'clear') {
            if (powerLensSv[0] >= 0.00 && powerLensSv[0] <= 2.00) {
                clickLensOptionByIndex(0);
            } else if (powerLensSv[0] > 2.00 && powerLensSv[0] <= 4.75) {
                clickLensOptionByIndex(1);
            } else if (powerLensSv[0] > 4.75 && powerLensSv[0] <= 10.00) {
                clickLensOptionByIndex(2);
            } else if (powerLensSv[0] > 10.25) {
                remPriceCart();
            }
        }
    }
    
    if (use.value == 'distance' || use.value == 'reading' || use.value == 'nearadd') {
        if (types.value == 'sunglasses') {
            if (powerLensSv[0] >= 0.00 && powerLensSv[0] <= 2.00) {
                clickLensOptionByIndex(3);
            } else if (powerLensSv[0] > 2.00 && powerLensSv[0] <= 8.00) {
                clickLensOptionByIndex(4);
            } else if (powerLensSv[0] > 6) {
                remPriceCart();
            }
        }
    }
    if (use.value == 'distance' || use.value == 'reading' || use.value == 'nearadd') {
        if (types.value == 'transitions') {
            if (powerLensSv[0] >= 0.00 && powerLensSv[0] <= 4.00) {
                clickLensOptionByIndex(5);
            } else if (powerLensSv[0] > 4.00 && powerLensSv[0] <= 8.00) {
                clickLensOptionByIndex(6);
            } else if (powerLensSv[0] > 8) {
                remPriceCart();
            }
        }
    }
    if (use.value == 'distance' || use.value == 'reading' || use.value == 'nearadd') {
        if (types.value == 'bluelight') {
            if (powerLensSv[0] >= 0.00 && powerLensSv[0] <= 3.00) {
                clickLensOptionByIndex(7);
            } else if (powerLensSv[0] > 3.00 && powerLensSv[0] <= 6) {
                clickLensOptionByIndex(8);
            } else if (powerLensSv[0] > 6 && powerLensSv[0] <= 7.50) {
                clickLensOptionByIndex(9);
            } else if (powerLensSv[0] > 8) {
                remPriceCart();
            }
        }
    }
    if (use.value == 'distance' || use.value == 'reading' || use.value == 'nearadd') {
        if (types.value == 'polarised') {
            if (powerLensSv[0] >= 0.00 && powerLensSv[0] <= 3.00) {
                clickLensOptionByIndex(10);
            } else if (powerLensSv[0] > 3.00 && powerLensSv[0] <= 6.00) {
                clickLensOptionByIndex(11);
            } else if (powerLensSv[0] > 6) {
                remPriceCart();
            }
        }
    }
    // Muliti focals > bifocals and varifocal parameters and prices
    const powerLensSb = powerM.sort((a, b) => {
        return b - a
    });

    if (use.value == 'bifocal' && segShape.value == 'd28' && types.value == 'clear') {
        if (powerLensSb[0] >= 0.00 && powerLensSb[0] <= 2.00) {
            clickLensOptionByIndex(12);
        } else if (powerLensSb[0] > 2.00 && powerLensSb[0] <= 6.00) {
            clickLensOptionByIndex(13);
        } else if (powerLensSb[0] > 6) {
            remPriceCart();
        }
    }
    if (use.value == 'bifocal' && segShape.value == 'r24' && types.value == 'clear') {
        if (powerLensSb[0] >= 0.00 && powerLensSb[0] <= 6.00) {
            clickLensOptionByIndex(14);
        } else if (powerLensSb[0] > 6) {
            remPriceCart();
        }
    }
    if (use.value == 'bifocal' && segShape.value == 'd28' && types.value == 'sunglasses') {
        if (powerLensSb[0] >= 0.00 && powerLensSb[0] <= 2.00) {
            clickLensOptionByIndex(15);
        } else if (powerLensSb[0] > 2.00 && powerLensSb[0] <= 6.00) {
            clickLensOptionByIndex(16);
        } else if (powerLensSb[0] > 6) {
            remPriceCart();
        }
    }
    if (use.value == 'bifocal' && segShape.value == 'r24' && types.value == 'sunglasses') {
        if (powerLensSb[0] >= 0.00 && powerLensSb[0] <= 6.00) {
            clickLensOptionByIndex(17);
        } else if (powerLensSb[0] > 6) {
            remPriceCart();
        }
    }
    if (use.value == 'bifocal' && segShape.value == 'd28' && types.value == 'transitions') {
        if (powerLensSb[0] >= 0.00 && powerLensSb[0] <= 6.50 && addVal.value <= 3.00) {
            clickLensOptionByIndex(18);
        } else if (powerLensSb[0] > 6.50) {
            remPriceCart();
        }
    }
    if (use.value == 'bifocal' && segShape.value == 'd28' && types.value == 'bluelight') {
        if (powerLensSb[0] >= 0.00 && powerLensSb[0] <= 7.50 && addVal.value <= 3.50) {
            clickLensOptionByIndex(19);
        } else if (powerLensSb[0] > 7.75) {
            remPriceCart();
        }
    }
    if (use.value == 'bifocal' && types.value == 'polarised') {
        if (powerLensSb[0] >= 0.00 && powerLensSb[0] <= 6.00) {
            clickLensOptionByIndex(20);
        } else if (powerLensSb[0] > 6.00) {
            remPriceCart();
        }
    }
    if (use.value == 'varifocal' && types.value == 'clear') {
        if (powerLensSb[0] >= 0.00 && powerLensSb[0] <= 2.00) {
            clickLensOptionByIndex(21);
        } else if (powerLensSb[0] > 2.00 && powerLensSb[0] <= 4.75) {
            clickLensOptionByIndex(22);
        } else if (powerLensSb[0] > 4.75 && powerLensSb[0] <= 8.00) {
            clickLensOptionByIndex(23);
        } else if (powerLensSb[0] > 8) {
            remPriceCart();
        }
    }
    if (use.value == 'varifocal' && types.value == 'sunglasses') {
        if (powerLensSb[0] >= 0.00 && powerLensSb[0] <= 3.00) {
            clickLensOptionByIndex(24);
        } else if (powerLensSb[0] > 3.00 && powerLensSb[0] <= 6.00) {
            clickLensOptionByIndex(25);
        } else if (powerLensSb[0] > 6) {
            remPriceCart();
        }
    }
    if (use.value == 'varifocal' && types.value == 'transitions') {
        if (powerLensSb[0] >= 0.00 && powerLensSb[0] <= 3.00) {
            clickLensOptionByIndex(26);
        } else if (powerLensSb[0] > 3.00 && powerLensSb[0] <= 8.00) {
            clickLensOptionByIndex(27);
        } else if (powerLensSb[0] > 8) {
            remPriceCart();
        }
    }
    if (use.value == 'varifocal' && types.value == 'polarised') {
        if (powerLensSb[0] >= 0.00 && powerLensSb[0] <= 3.00) {
            clickLensOptionByIndex(28);
        } else if (powerLensSb[0] > 3.00 && powerLensSb[0] <= 6.00) {
            clickLensOptionByIndex(29);
        } else if (powerLensSb[0] > 6) {
            remPriceCart();
        }
    }

    if (use.value == 'bifocal' && segShape.value == 'r24' && types.value == 'bluelight') {
        if (powerLensSb[0] >= 0.00 && powerLensSb[0] <= 8.00 && addVal.value <= 3.50) {
            clickLensOptionByIndex(30);
        } else if (powerLensSb[0] > 8.25) {
            remPriceCart();
        }
    }
})

/* =========================================================
   MM Dawn: Disable Add to Cart until required fields selected
   - Your required fields (.req) are OUTSIDE the /cart/add form
   - Uses the real product form: form.form[action="/cart/add"]
   - Uses the real ATC button: .product-form__submit[name="add"]
   ========================================================= */
document.addEventListener("DOMContentLoaded", () => {
  // 1) Grab the REAL product add form (ignore the installment one)
  const form = document.querySelector('form.form[action="/cart/add"]');
  if (!form) return;

  // 2) Grab the REAL add to cart button
  const addBtn =
    document.querySelector('#ProductSubmitButton-template--27279427895670__main') ||
    form.querySelector('button.product-form__submit[name="add"]') ||
    form.querySelector('button[name="add"]') ||
    form.querySelector('button[type="submit"]');

  if (!addBtn) return;

  // Avoid double-binding
  if (form.dataset.mmDisableAddBound === "true") return;
  form.dataset.mmDisableAddBound = "true";

  // 3) Ensure validation message exists under the button
  let validationBox = document.querySelector(".mm-validation");
  if (!validationBox) {
    validationBox = document.createElement("div");
    validationBox.className = "mm-validation d-none";
    validationBox.setAttribute("aria-live", "polite");
    addBtn.parentElement?.appendChild(validationBox);
  }

  // Helpers
  function isVisible(el) {
    if (!el) return false;
    const style = window.getComputedStyle(el);
    if (style.display === "none" || style.visibility === "hidden") return false;
    if (el.offsetParent === null) return false;
    return true;
  }

  function getRequiredFields() {
    // Your required fields are select/input/file with class .req and name properties[...]
    return Array.from(document.querySelectorAll(".req"))
      .filter((el) => el.matches("select, input, textarea"))
      .filter((el) => !el.disabled)
      .filter((el) => (el.name || "").startsWith("properties["))
      .filter((el) => isVisible(el) || isVisible(el.closest("label")) || true);
  }

  function fieldIsValid(el) {
    if (!el) return true;

    // File required
    if (el.type === "file") {
      return el.files && el.files.length > 0;
    }

    // Select required
    if (el.tagName === "SELECT") {
      return (el.value || "").trim() !== "";
    }

    // Checkbox required
    if (el.type === "checkbox") {
      return !!el.checked;
    }

    // Radio required (by name group)
    if (el.type === "radio") {
      const name = el.getAttribute("name");
      if (!name) return el.checked;
      const group = Array.from(document.querySelectorAll(`input[type="radio"][name="${CSS.escape(name)}"]`))
        .filter((r) => !r.disabled)
        .filter((r) => isVisible(r) || isVisible(r.closest("label")));
      return group.some((r) => r.checked);
    }

    // Text/number/textarea required
    return (el.value || "").trim() !== "";
  }

  function isValid() {
    const fields = getRequiredFields();
    if (!fields.length) return true;

    // Avoid repeating radio-group checks
    const seenRadioNames = new Set();

    for (const el of fields) {
      if (el.type === "radio") {
        const name = el.getAttribute("name") || "__noname__";
        if (seenRadioNames.has(name)) continue;
        seenRadioNames.add(name);
      }

      if (!fieldIsValid(el)) return false;
    }
    return true;
  }

  function setMessage(msg) {
    if (!validationBox) return;
    if (msg) {
      validationBox.textContent = msg;
      validationBox.classList.remove("d-none");
    } else {
      validationBox.textContent = "";
      validationBox.classList.add("d-none");
    }
  }

  function lockButton() {
    addBtn.disabled = true;
    addBtn.classList.add("mm-disabled");
    addBtn.setAttribute("aria-disabled", "true");
  }

  function unlockButton() {
    addBtn.disabled = false;
    addBtn.classList.remove("mm-disabled");
    addBtn.removeAttribute("aria-disabled");
  }

  function updateState(showMessageWhenInvalid = false) {
    if (isValid()) {
      unlockButton();
      setMessage("");
    } else {
      lockButton();
      if (showMessageWhenInvalid) {
        setMessage("Please complete all required selections before adding to cart.");
      } else {
        setMessage("");
      }
    }
  }

  // Initial lock
  updateState(false);

  // Watch changes on required fields anywhere
  document.addEventListener("change", (e) => {
    if (e.target && (e.target.classList?.contains("req") || e.target.closest?.(".req"))) updateState(false);
  });

  document.addEventListener("input", (e) => {
    if (e.target && (e.target.classList?.contains("req") || e.target.closest?.(".req"))) updateState(false);
  });

  // Clicking while disabled shows the message
  addBtn.addEventListener("click", () => {
    if (addBtn.disabled) updateState(true);
  });

  // Safety net: if submit happens anyway, block it
  form.addEventListener(
    "submit",
    (e) => {
      if (!isValid()) {
        e.preventDefault();
        e.stopImmediatePropagation();
        updateState(true);
        return false;
      }
    },
    true
  );
});

document.addEventListener("DOMContentLoaded", () => {
  const sticky = document.getElementById("mm-sticky-atc");
  const stickyBtn = document.getElementById("mm-sticky-btn");
  const stickyPrice = document.getElementById("mm-sticky-price");
  if (!sticky || !stickyBtn || !stickyPrice) return;

  // Your real Dawn ATC button (same one we used earlier)
  const realBtn =
    document.querySelector('#ProductSubmitButton-template--27279427895670__main') ||
    document.querySelector('button.product-form__submit[name="add"]') ||
    document.querySelector('form.form[action="/cart/add"] button[type="submit"]');

  if (!realBtn) return;

  // Price element: Dawn commonly uses .price-item--regular, but we’ll be flexible
  const priceEl =
    document.querySelector(".price .price-item--regular") ||
    document.querySelector(".price__regular .price-item") ||
    document.querySelector("[data-price]") ||
    document.querySelector(".price-item");

  function sync() {
    // mirror disabled state
    stickyBtn.disabled = !!realBtn.disabled;
    stickyBtn.classList.toggle("mm-disabled", !!realBtn.disabled);

    // mirror button label
    const txt = (realBtn.textContent || "").trim();
    if (txt) stickyBtn.textContent = txt;

    // mirror price text
    const ptxt = priceEl ? (priceEl.textContent || "").trim() : "";
    if (ptxt) stickyPrice.textContent = ptxt;
  }

  // Click sticky -> click real (keeps all validation + Dawn logic)
  stickyBtn.addEventListener("click", () => {
    realBtn.click();
  });

  // Show/hide sticky based on whether real button is visible
  const io = new IntersectionObserver(
    (entries) => {
      const entry = entries[0];
      const realVisible = entry.isIntersecting;

      if (realVisible) {
        sticky.classList.remove("is-active");
        document.body.classList.remove("mm-sticky-atc-padding");
        sticky.setAttribute("aria-hidden", "true");
      } else {
        sticky.classList.add("is-active");
        document.body.classList.add("mm-sticky-atc-padding");
        sticky.setAttribute("aria-hidden", "false");
        sync();
      }
    },
    { threshold: 0.15 }
  );

  io.observe(realBtn);

  // Keep it updated if price/button state changes (variants, your validator, etc.)
  const mo = new MutationObserver(sync);
  mo.observe(realBtn, { attributes: true, childList: true, subtree: true });
  if (priceEl) mo.observe(priceEl, { childList: true, subtree: true });

  // initial sync
  sync();
});

